import mountCarousel from "./initializeCarousel";
import registerEventListeners from "./EventListeners";

registerEventListeners();
mountCarousel();
